import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=894d7b16&scoped=true"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"
import style0 from "./Approve.vue?vue&type=style&index=0&id=894d7b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894d7b16",
  null
  
)

export default component.exports